import { Navigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import {
  CLIENT_EXPLORE_EXPOS_TAB_PARAM,
  CLIENT_EXPLORE_PATH,
  GUEST_CORRIDORS_CLUSTERS_PATH,
  GUEST_REGIONAL_SECTOR_EXPERTS_PATH,
  guestExploreListPathFromTabParam,
} from "@/pages/discover/discoverExplore.const";

/** Wraps `/` DiscoverPage: redirects `?tab=experts|corridors|expos` only. */
export function GuestHomeExploreTabRedirect({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  if (
    tab === "experts" ||
    tab === "corridors" ||
    tab === "expos" ||
    tab === CLIENT_EXPLORE_EXPOS_TAB_PARAM
  ) {
    return <Navigate to={guestExploreListPathFromTabParam(tab)} replace />;
  }
  return <>{children}</>;
}

/** Logged-in Explore: `?tab=expos` → `?tab=global-events-exhibitions`. */
export function ClientExploreExposTabRedirect({ children }: { children: React.ReactNode }) {
  const [searchParams] = useSearchParams();
  if (searchParams.get("tab") !== "expos") return <>{children}</>;
  const next = new URLSearchParams(searchParams);
  next.set("tab", CLIENT_EXPLORE_EXPOS_TAB_PARAM);
  const qs = next.toString();
  return <Navigate to={`${CLIENT_EXPLORE_PATH}${qs ? `?${qs}` : ""}`} replace />;
}

/** `/discover` → `/` or tab-specific guest list path. */
export function GuestDiscoverIndexRedirect() {
  const [searchParams] = useSearchParams();
  return <Navigate to={guestExploreListPathFromTabParam(searchParams.get("tab"))} replace />;
}

/** `/discover/corridor/:industry/:headUserId` → `/corridors-clusters/...` (preserve section search). */
export function LegacyGuestCorridorProfileRedirect() {
  const { industry, headUserId } = useParams<{ industry: string; headUserId: string }>();
  const location = useLocation();
  if (!industry || !headUserId) {
    return <Navigate to={GUEST_CORRIDORS_CLUSTERS_PATH} replace />;
  }
  return (
    <Navigate
      to={`${GUEST_CORRIDORS_CLUSTERS_PATH}/${encodeURIComponent(industry)}/${encodeURIComponent(headUserId)}${location.search}`}
      replace
    />
  );
}

/** `/discover/expert/company/:id` → `/regional-sector-experts/:id`. */
export function LegacyGuestExpertProfileRedirect() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  if (!id) {
    return <Navigate to={GUEST_REGIONAL_SECTOR_EXPERTS_PATH} replace />;
  }
  return (
    <Navigate
      to={`${GUEST_REGIONAL_SECTOR_EXPERTS_PATH}/${encodeURIComponent(id)}${location.search}`}
      replace
      state={location.state}
    />
  );
}
